import * as React from 'react';
import { TApiChemicalProductEntity } from '../../../types/Chemical';
import { ChangeEvent } from 'react';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ChemicalList from '../../chemicals/ChemicalList';

interface IChemicalProps {
  chemicals: Array<TApiChemicalProductEntity>;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
  })
);

const Chemical: React.FC<IChemicalProps> = ({
  chemicals,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange('expandedChemical')}
      key={'expandedChemical'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`expandedChemicalnbh-content`}
        id={`expandedChemicalbh-header`}
      >
        <Typography className={classes.heading}>{t("process.chemicals")}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        <div className={classes.root}>
          <ChemicalList chemicals={chemicals} />
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

export default Chemical;
